import { CreateElement } from '@src/vue'
import { Component } from 'vue-property-decorator'

import { Button } from '@src/elements/button/button'
import { Input } from '@src/elements/input/input'
import { Textarea } from '@src/elements/input/textarea'
import { Body2 } from '@src/elements/typography/typography'
import { Icon } from '@src/elements/icon/icon'
import { CreateNote } from '@src/routes/members/components/notes/create'
import Note from '@src/data/note'
import { snakecaseKeys } from '@src/util/functions'
import EventBus from '@src/lib/event_bus'

@Component
export class WizardCreateNote extends CreateNote {

  constructor () {
    super()
  }

  render (h: CreateElement) {
    if (!this.note) {
      return
    }

    const tags = !this.note ? /* istanbul ignore next: the note is checked above */ [] : this.note!.tags.map((tag: string, index: number) => {
      return <Body2 class='note-tag'>
        {tag}
        <Icon name='util/close-circled' click={() => this.removeTag(index)} /></Body2>
    })

    return <div class='create-note'>
      <div>
        <Input ref='noteTags' class={(this.hasError('TAGS') ? 'error' : '')} icon='util/label' label={this.$t('PAGE.MEMBERS.NOTES.ENTER_NOTE_TAGS')}
               valueChanged={this.checkAddTag} focusLost={this.addTag} value={this.tagsInputValue} />

        <div class='row tag-list'>
          {tags}
        </div>

        <Textarea value={this.note!.text} class={this.hasError('NOTES') ? 'error' : null} label={this.$t('PAGE.MEMBERS.NOTES.WRITE_NOTE')}
                  change={(value) => this.note!.text = value} />

        <div class='btn-row'>
          <Button type={'elevated'} ref='saveBtn' label={this.note!.id ? this.$t('SAVE') : this.$t('PAGE.MEMBERS.NOTES.ADD_NOTE')} click={this.save} />
        </div>
      </div>
    </div>
  }

  createNote (note) {
    return this.apiClient.post(`${this.$route.params.id}/notes`, { note: snakecaseKeys(note) })
      .then((response: any) => {
        EventBus.trigger('reloadNotes')
        this.$store.dispatch('setNote', new Note({ createdAt: new Date(), tags: [], text: '' }))
        this.$store.dispatch('addNoteIdToCheckup', response.note.id)
      })
      .catch((error) => {
        console.log('cannot create note', error)
      })
  }

  editNote (note) {
    return this.apiClient.put(`${this.$route.params.id}/notes/${note.id}`, { note: snakecaseKeys(note) })
      .then((response: any) => {
        EventBus.trigger('reloadNotes')
        this.$store.dispatch('setNote', new Note({ createdAt: new Date(), tags: [], text: '' }))
        this.$store.dispatch('addNoteIdToCheckup', response.note.id)
      })
      .catch((error) => {
        console.log('cannot edit note', error)
      })
  }
}
